import React from 'react';
import { withRouter } from 'react-router-dom';

import AppContext from '../services/Context';
import styled from '../styled-components';

export default withRouter(
    ({ children, location }: { children?: React.ReactNode; location: { pathname: string, state: string } }) => (
        <AppContext.Consumer>
            {({ theme, authorized }) => {
                return (
                    <Wrapper theme={theme}>
                        {children}
                    </Wrapper>
                )
            }}
        </AppContext.Consumer>
    ),
);

const Wrapper = styled.div`
  flex: 1;
  padding: 40px 50px;
  margin-left: ${({ theme }) => theme.sidebarSize || '150px'};
  margin-top: ${({ theme }) => theme.headerHeight || '150px'};
  max-width:100%;
  width: 100%;
  .process-name-style {
    font-size: 36px;
    font-weight: bold;
    padding-bottom: 30px;
  }
`;
